export default "__VITE_PUBLIC_ASSET__ba7c36e3__"